import ReviewIcon from "../../assets/images/review-icon.png";
import React from "react";
import "./review-warning.css";

const ReviewWarning = () => {
    return (
        <div className="review-warning">
            <img src={ReviewIcon} />
            <span>Heads-up: New or edited templates are sent to WhatsApp for review. Approval typically completes within a few minutes, but may take up to 24 hours.</span>
        </div>
    );
}

export default ReviewWarning;